





































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import MenuReportActionsMixin from '@/views/layout/navigation/mixins/menu-report-actions-mixin';

@Component
export default class MenuReport extends mixins(
  MenuReportActionsMixin,
  UrlMixin
) {
  get reportMultiMenuList() {
    return this.isReport()
      ?  [
        this.itemActions.drilldown,
        {
          ...this.itemActions.drilldownContinueNewTab,
          icon: null
        },
        {
          ...this.itemActions.drilldownOpenInNewTab,
          icon: null as string
        }
      ]
      : [
        this.itemActions.drilldownHome
      ];
  }

  get excludeMultiMenuList() {
    return this.isReport()
      ?  [
        this.itemActions.exclude,
        {
          ...this.itemActions.excludeContinueNewTab,
          icon: null
        },
        {
          ...this.itemActions.excludeStartNewTab,
          icon: null
        }
      ]
      : [
        this.itemActions.excludeHome
      ];
  }

  get editMultiMenuList() {
    return [
      this.itemActions.edit,
      this.itemActions.editDrilldown
    ];
  }

  get editMultiMenuListFiltered() {
    return this.editMultiMenuList
      .filter((item) => typeof item.showCondition === 'undefined' || item.showCondition);
  }

  get createItemList() {
    return [
      this.itemActions.create,
      this.itemActions.createFromTemplate,
      this.itemActions.createCampaign,
    ]
  }

  get importPlanLimits() {
    switch (this.$route.params.type){
      case 'offers':
        return 'importOffers'
      case 'landings':
        return 'importLandings'
    }
  }

  get createItemListFiltered() {
    return this.createItemList
      .filter((item) => typeof item.showCondition === 'undefined' || item.showCondition);
  }

  get itemMenuFiltered() {
    return this.itemMenu
      .filter((item) => typeof item.showCondition === 'undefined' || item.showCondition);
  }

  get itemMenuFilteredAndEnabled() {
    return this.itemMenuFiltered
      .filter((item) => !item.disabled);
  }

  get isBasicReport() {
    return !this.notReports.includes(this.computedType);
  }

  get notReports() {
    return [ 'conversions', 'postbacks', 'errors', 'live-visits', 'live-clicks' ];
  }
}
